module.exports = __webpack_public_path__ + "img/mj5.3b97c31f.png";